"use client";

import { useSyncExternalStore } from "react";

/**
 * Whether the viewport is past the point where the facet opens anchored.
 *
 * **Narrow exception** to the project's CSS-only presentation rule: the facet layer is a
 * structural difference, not a stylistic one, and rendering both while hiding one would
 * mount two focus managers competing for the same state. The hydration risk the rule
 * guards against is absent here, since the layer only exists after a tap.
 */

/** Handoff §7.3: above this the facet opens anchored to its own chip. */
export const ANCHORED_FACET_MIN_WIDTH = 1024;

const QUERY = `(min-width: ${ANCHORED_FACET_MIN_WIDTH}px)`;

function subscribe(onChange: () => void) {
  const mediaQuery = window.matchMedia(QUERY);
  mediaQuery.addEventListener("change", onChange);

  return () => mediaQuery.removeEventListener("change", onChange);
}

export function useIsWideViewport(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(QUERY).matches,
    // No width on the server. `false` picks the bottom sheet, which works at any width:
    // erring toward the form that does not break.
    () => false,
  );
}
